import React from 'react'
import './style.module.scss'
import type { ContentProps } from './Content.type'

export function Content({
  large,
  open,
  small,
  reversed,
  legal,
  className = '',
  children,
  testId,
  ...rest
}: Readonly<ContentProps>) {
  const classNames = [
    'Content',
    large && 'Content--large',
    open && 'Content--open',
    small && 'Content--small',
    reversed && 'Content--reversed',
    legal && 'Content--legal',
    className
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={classNames} {...rest} data-testid={testId}>
      {children}
    </div>
  )
}
